// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {getLotteryTicketsService} from "../services/getLotteryTickets.service";

const useGetLotteryTickets = () => {
  const {data, isLoading, isSuccess, error, refetch} = useQuery({
    queryKey: ["lottery_tickets"],
    queryFn: getLotteryTicketsService,
    onError: () => undefined,
    staleTime: 300,
  });

  return {
    data,
    isLoading,
    isSuccess,
    error,
    refetch,
  };
};

export default useGetLotteryTickets;
